import axios from "axios";
import { toast } from "react-toastify";
import { getLocalJWT, logout } from "../components/functions/utilities";
import { history } from "../Router/History";

let API = axios.create({
  baseURL: `${import.meta.env.VITE_JIGSAW_DEV_REST_LOCATION}`,
  responseType: "json",
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

API.interceptors.request.use((req) => {
  let token = getLocalJWT();
  if (token) req.headers.Authorization = "Bearer " + token;
  return req;
});

API.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (error.response?.status === 403) {
      toast.error("You do not have access to the workspace");
      history.push("/Reports");
    }
    if (error.response?.status === 401) {
      logout();
      history.replace("/login");
    }
    //
    return Promise.reject(error);
  }
);

export default API;
